<section class="profile">
  <div class="container">
    <form [formGroup]="profileForm" (ngSubmit)="update()" #proForm="ngForm">

      <div class="profile-card">

        <h3 class="mb-4">Update Password</h3>

        <div class="row">

          <!-- New Password -->
          <div class="col-md-6 mb-3">
            <label>New Password <span class="text-danger">*</span></label>
            <input type="password"
                   class="form-control"
                   formControlName="newpassword">

            <small class="text-danger"
              *ngIf="(proForm.submitted || newpassword.touched) && newpassword.errors?.required">
              New Password is required.
            </small>
          </div>

          <!-- Confirm Password -->
          <div class="col-md-6 mb-3">
            <label>Confirm Password <span class="text-danger">*</span></label>
            <input type="password"
                   class="form-control"
                   formControlName="confirmpassword">

            <small class="text-danger"
              *ngIf="(proForm.submitted || confirmpassword.touched) && confirmpassword.errors?.required">
              Confirm Password is required.
            </small>
          </div>

        </div>

        <!-- Button -->
        <div class="text-end">
          <button type="submit" class="btn btn-warning px-4">
            Update
          </button>
        </div>

      </div>

    </form>
  </div>
</section>